import React from 'react';

function AlbumCard({ album, onSelect }) {
  const coverUrl = album.imageUrl || album.image_url || 'https://images.unsplash.com/photo-1557200134-90327ee9fafa?auto=format&fit=crop&q=80&w=300&h=300';
  const releaseYear = album.release_year || album.releaseYear || (album.created_at ? new Date(album.created_at).getFullYear() : '—');
  const trackText = `${album.songCount || 0} Tracks`;
  const labelText = album.recordLabelName || 'Recode label';

  return (
    <div 
      className="album-card" 
      onClick={() => onSelect && onSelect(album)}
      style={{ cursor: 'pointer' }}
    >
      {/* Cover Image Box */}
      <div className="album-cover-box">
        <img src={coverUrl} alt={album.name} className="album-cover-img" />
      </div>

      {/* Album Information */}
      <div className="album-info-box">
        <h3 className="album-title">{album.name}</h3>
        <span className="album-tag">{album.tag || 'Album tag'}</span>
      </div>

      {/* Metadata Rows */}
      <div className="album-metadata-box">
        {/* Row 1: Calendar Icon + Year */}
        <div className="album-meta-row">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
          </svg>
          <span>{releaseYear}</span>
        </div>

        {/* Row 2: Music Icon + Tracks */}
        <div className="album-meta-row">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 18V5l12-2v13" />
            <circle cx="6" cy="18" r="3" />
            <circle cx="18" cy="16" r="3" />
          </svg>
          <span>{trackText}</span>
        </div>

        {/* Row 3: Label Icon + Record Label */}
        <div className="album-meta-row">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
            <line x1="7" y1="7" x2="7.01" y2="7" />
          </svg>
          <span>{labelText}</span>
        </div>
      </div>

      {/* View Album Button */}
      <button 
        type="button" 
        className="view-album-btn"
        onClick={(e) => {
          e.stopPropagation();
          onSelect && onSelect(album);
        }}
      >
        <span>View Album</span>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </button>
    </div>
  );
}

export default AlbumCard;
